// @flow

import { all, call, put, takeEvery } from "redux-saga/effects";
import type { Action } from "redux-action";
import http from "@http";
import actionCreators from "@modules/shared/actionCreator";
import { GetClientShiftPatterns } from "@modules/shared/constants/actions";

type ShiftPatternsRequest = $Exact<{
  clientId: string,
}>;

export function* onGetClientShiftPatterns({
  payload,
}: Action<ShiftPatternsRequest>): Generator<*, void, Object> {
  if (!payload || !payload.clientId) {
    throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
  }

  try {
    const response = yield call(
      http.get,
      `/api/v1/service-admin/client/${payload.clientId}/shift-pattern`,
      {
        params: {
          limit: 100,
        },
      },
    );

    yield put(actionCreators.GetClientShiftPatternsSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetClientShiftPatternsError(e.response));
  }
}

export function* ShiftPatternSagas(): Generator<*, void, void> {
  yield all([takeEvery(GetClientShiftPatterns, onGetClientShiftPatterns)]);
}

export default ShiftPatternSagas;
